import React from 'react'

const SettingLayOut = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}

export default SettingLayOut